import React, { useMemo } from 'react';

import uniq from 'lodash/uniq';
import without from 'lodash/without';

import {
  VirtualizedListItem,
  Grid,
  Divider,
  IconButton,
  ReadMoreIcon,
  PlaylistRemoveIcon,
} from '@gogame/components';

import PreviewREList from './PreviewREList';
import SelectableREList from './SelectableREList';

const EMPTY_VALUE = [];
const TRACK_BY = 'id';

const REPicker = ({
  options,
  filteredOptions,
  searchQuery,
  value = EMPTY_VALUE,
  onChange,
  availableLabel,
  selectedLabel,
}) => {
  const visibleSelectedOptions = useMemo(() => {
    const currentOptions = searchQuery ? filteredOptions : options;

    return currentOptions.filter((opt) => value.includes(opt[TRACK_BY]));
  }, [options, filteredOptions, value, searchQuery]);

  const filteredOptionIds = useMemo(
    () => filteredOptions?.map((opt) => opt[TRACK_BY]),
    [filteredOptions]
  );

  const handleSelectAll = () => {
    onChange(uniq([...value, ...filteredOptionIds]));
  };
  const handleClearAll = () => onChange(without(value, ...filteredOptionIds));
  const handleDelete = (deletedOption) => {
    const newValue = options
      .filter((opt) => opt.id !== deletedOption.id)
      .map((opt) => opt[TRACK_BY])
      .filter((optV) => value.includes(optV));

    onChange(newValue);
  };

  const selectableOptions = filteredOptions.filter(
    ({ id }) => !value.includes(id)
  );

  const handleSelect = (v) => {
    const currentIndex = value.indexOf(v);
    let newValue = [...value];

    if (currentIndex === -1) {
      newValue.push(v);
    } else {
      newValue.splice(currentIndex, 1);
    }
    onChange(newValue);
  };

  return (
    <Grid
      container
      style={{
        height: '100%',
      }}
    >
      <Grid item container direction={'column'} xs={6}>
        <VirtualizedListItem
          label={availableLabel}
          style={{ height: 48 }}
          actionCount={3}
          secondaryAction={
            <IconButton
              color={'primary'}
              onClick={handleSelectAll}
              tooltip={'Select All'}
              icon={<ReadMoreIcon />}
              disabled={!selectableOptions.length}
            />
          }
        />
        <Divider style={{ marginTop: -1 }} />
        <Grid item fullHeight style={{ marginRight: 1 }}>
          <SelectableREList
            options={selectableOptions}
            onChange={handleSelect}
          />
        </Grid>
      </Grid>
      <Divider orientation={'vertical'} flexItem />
      <Grid item container direction={'column'} xs>
        <VirtualizedListItem
          label={selectedLabel}
          style={{ height: 48 }}
          secondaryAction={
            <IconButton
              color={'primary'}
              onClick={handleClearAll}
              tooltip={'Clear All'}
              icon={<PlaylistRemoveIcon />}
              disabled={!visibleSelectedOptions.length}
            />
          }
        />
        <Divider style={{ marginTop: -1 }} />
        <Grid item fullHeight>
          <PreviewREList
            options={visibleSelectedOptions}
            onDelete={handleDelete}
          />
        </Grid>
      </Grid>
    </Grid>
  );
};

export default REPicker;
